module.exports = __webpack_public_path__ + "img/switch-flip.d9a61297.jpg";